/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-props-no-spreading */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import ImageLabel from '@app/components/AdLabel/ImageLabel';
import UrgentJobLabel from '@app/components/UrgentJob/UrgentJobLabel';
import Image from 'next/image';
import Style from './AdThumbnail.module.scss';

const handleErrorImage = (e) => {
  const image = e.target;
  image.style.display = 'none';
};

const AdThumbnail = ({
  image,
  title,
  ribbonAd,
  handleImplementClickAdView,
  isEntitlement,
  isUrgentJobAd,
  imageLabelConfig,
}) => (
  <div className={Style.thumbnailWrapper}>
    <div
      className={`${Style.thumbnailImg} ${isEntitlement ? Style.thumbnailImgEntitlement : ''} ${
        !isEntitlement && !isUrgentJobAd ? Style.thumbnailImgWithAdLabel : ''
      }`}
      onClick={(event) => handleImplementClickAdView(event)}
    >
      {imageLabelConfig && imageLabelConfig?.image && <ImageLabel config={imageLabelConfig} />}
      {image && (
        <Image
          alt={title}
          layout="fill"
          objectFit="cover"
          onError={handleErrorImage}
          src={image.replace('http://', '//')}
          loading="lazy"
        />
      )}
      {/* {image !== '' && numberOfImages > 1 && (
        <div className={Style.imageNum}>
          <span className={Style.text}>{numberOfImages}</span>
        </div>
      )} */}
      {ribbonAd && ribbonAd}
      {isUrgentJobAd && <UrgentJobLabel />}
    </div>
  </div>
);

AdThumbnail.defaultProps = {
  image: '',
  title: '',
  ribbonAd: null,
  isEntitlement: false,
  isUrgentJobAd: false,
  imageLabelConfig: {},
};

AdThumbnail.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  ribbonAd: PropTypes.oneOfType([() => null, PropTypes.object]),
  isEntitlement: PropTypes.bool,
  isUrgentJobAd: PropTypes.bool,
  imageLabelConfig: PropTypes.shape({
    image: PropTypes.string,
  }),
};

export default memo(AdThumbnail);
